import { RemoveSectionsRegistrationAttributesCommand } from '../../../registration_attributes/commands/remove_section_registration_attributes_command';
import { SaveSwapCommand } from '../../commands/save_swap_command';
import { TransientAccessCredEventNames } from '../../../prevent_transient_access/constants/transient_access_cred_constants';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { PreventTransientAccessQuery } from '../../../prevent_transient_access/queries/prevent_transient_access_query';
import { HILForm } from '../../../interfaces/scheduler_interfaces';
import { SectionSwapPreviewQuery } from '../../queries/section_swap_preview_query';
import { SubmitRegAttrFormAndGetOutputCommand } from '../../../registration_attributes/commands/submit_reg_attr_form_and_get_output_command';
import { SectionRegistrationAttributesQuery } from '../../../registration_attributes/queries/section_registration_attributes_query';
import { CourseSchedulerConstant } from '../../../views/course_scheduler/constants/course_scheduler_constants';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { SectionSwapModel } from '../../models/course_section_swap_model';
import { SectionSwapServant } from '../../servants/section_swap_servant';
import { TermPinServant } from '../../../components/term_pin/servants/term_pin_servant';
import { SchedulerCustomTextQuery } from '../../../views/course_scheduler/queries/scheduler_custom_text_query';
import { RemoveSectionSelectionCommand } from '../../../components/section_selections/commands/remove_section_selection_command';
import { RequestStateQuery } from '../../../request_state/queries/request_state_query';

export class SwapConfirmationController {
  private query: any;
  private heading: string = '';
  private showDialog: boolean = false;
  private showCourseTitle: boolean = false;
  private inCourseSwapMode: boolean = false;
  private sectionPins = {};
  private isPermissionPinsFeatureEnabled = false;
  private isTermPinFeatureEnabled = false;

  private performSwapBound = this.performSwap.bind(this);
  private cancelDialogBound = this.cancelDialog.bind(this);

  constructor(
    private ngCourseSectionSwapModel: SectionSwapModel,
    private $stateParams: ng.ui.IStateParamsService,
    private ngSectionSwapPreviewSwapQuery: SectionSwapPreviewQuery,
    private saveSwapCommand: SaveSwapCommand,
    private $timeout: ng.ITimeoutService,
    private saveTermPinCommand: ICommand,
    private ngTermPinServant: TermPinServant,
    private $state: ng.ui.IStateService,
    private ngSectionSwapServant: SectionSwapServant,
    private submitRegAttrFormAndGetOutputCommand: SubmitRegAttrFormAndGetOutputCommand,
    private ngCourseSchedulerConstant: typeof CourseSchedulerConstant,
    private removeSectionsRegistrationAttributesCommand: RemoveSectionsRegistrationAttributesCommand,
    private ngPreventTransientAccessQuery: PreventTransientAccessQuery,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngSchedulerCustomTextQuery: SchedulerCustomTextQuery,
    private ngSectionRegistrationAttributesQuery: SectionRegistrationAttributesQuery,
    private removeSectionSelectionCommand: RemoveSectionSelectionCommand,
    private ngRequestStateQuery: RequestStateQuery
  ) {
    this.ngComponentCommunicatorService.subscribe(TransientAccessCredEventNames.NEW_CRED_SAVED, this.performSwapBound);
    this.ngComponentCommunicatorService.subscribe(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.cancelDialogBound
    );
  }

  init() {
    this.inCourseSwapMode = _4.isEqual(_4.get(this.$stateParams, 'swapCourse', 'false'), 'true');
    this.heading = this.inCourseSwapMode
      ? 'Confirm Swap'
      : `Confirm Your New Times for
      ${_4.get(_4.head(this.ngSectionSwapPreviewSwapQuery.result.from), '_course.cd') || 'Selected Course'}`;
    this.showCourseTitle = this.inCourseSwapMode;
    this.isPermissionPinsFeatureEnabled = this.ngSectionSwapServant.isPermissionPinsFeatureEnabled();
    this.isTermPinFeatureEnabled = this.ngTermPinServant.isTermPinFeatureEnabled();
  }

  $onChanges() {
    this.init();
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release(TransientAccessCredEventNames.NEW_CRED_SAVED, this.performSwapBound);
    this.ngComponentCommunicatorService.release(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.cancelDialogBound
    );
  }

  submitRegAttrForm() {
    const toSectionIds = this.ngSectionSwapPreviewSwapQuery.result.to.map((section) => section.id);
    const formElement = document.querySelector(`#${CourseSchedulerConstant.swapConfirmationRegAttrFormId}`) as HILForm;

    return this.submitRegAttrFormAndGetOutputCommand(
      formElement,
      CourseSchedulerConstant.swapConfirmationRegAttrFormId,
      toSectionIds
    );
  }

  performSwap() {
    const userAuthRequired = this.ngPreventTransientAccessQuery.result.redirectToAuthWorkflow;

    if (userAuthRequired) {
      return this.submitRegAttrForm().then(() => {
        this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS);
      });
    }
    return this.submitRegAttrForm()
      .then((swapRegAttrs) => {
        this.saveTermPinCommand(this.$stateParams.termId).then(() => this.swap(swapRegAttrs));
      })
      .catch((e) => {
        // switch step tabs without filling the reg attr and initiate the swap action from auth cred form
        // this catch means the reg attr form output doesn't exist.
        if (this.ngPreventTransientAccessQuery.result.workflowEnabled) {
          this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS);
        }
        const formRenderingDelay = 500;
        this.$timeout(() => {
          this.submitRegAttrForm();
        }, formRenderingDelay);
      });
  }

  swap(swapRegAttrs?: Record<string, any>) {
    const fromData = _4.compact(
      this.ngCourseSectionSwapModel.read().swap_from_section_ids.map((section) => section.id)
    );
    const toData = _4.compact(this.ngCourseSectionSwapModel.read().swap_to_section_ids.map((section) => section.id));
    this.saveSwapCommand(
      this.$stateParams.termId,
      fromData,
      toData,
      this.sectionPins,
      swapRegAttrs,
      this.ngPreventTransientAccessQuery.result.output
    ).then(() => {
      fromData.map((sectionId) => this.removeSectionSelectionCommand(sectionId));
      this.cancelDialog();
      this.$timeout(() => {
        this.$state.go('my.schedule.registration');
      }, 1);
    });
  }

  onPinValueChanged(event: any) {
    const pin = event.detail.value;
    const toSectionIds: number[] = _4.compact(_4.map(this.ngCourseSectionSwapModel.read().swap_to_section_ids, 'id'));
    this._saveSectionPins(toSectionIds, pin);
  }
  _saveSectionPins(sectionIds: number[], pin: string) {
    _4.forEach(sectionIds, (sectionId: number) => {
      this.sectionPins[sectionId] = pin;
    });
  }
  cancelDialog() {
    const toSectionIds = this.ngCourseSectionSwapModel.read().swap_to_section_ids.map((section) => section.id);
    this.removeSectionsRegistrationAttributesCommand(toSectionIds).then(() => (this.showDialog = false));
  }
}

angular.module('capability-ng-scheduler').component('swapConfirmationDialog', {
  templateUrl: 'capability-ng-scheduler/src/swap/components/swap_confirmation_dialog/swap_confirmation_dialog.html',
  controller: SwapConfirmationController,
  bindings: {
    showDialog: '='
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/components/swap_confirmation_dialog/swap_confirmation_dialog.ts